"use strict";
var transform = require('common/transform');
var confirmModalCtrl = require('./confirmModalCtrl');
var hlp = require('common/helpers');
var controller = function($scope, $rootScope, $http, name, id, permissions, $uibModal) {
  var init = function() {
    $scope.name = name;
    $scope.id = id;
    $scope.permissions = permissions;
    $scope.initFields(name, id);
    $scope.getThesaurus();
    $scope.loadSources = ['ICONCLASS', 'GND', 'AAT', 'Wikidata'];
  };
  $scope.save = function() {
    if (id != null) {
      $scope.update(id);
    } else {
      $scope.create();
    }
  };
  $scope.openConfirmModal = function(modal) {
    var modalInstance = $uibModal.open({
      templateUrl: 'thesaurus/templates/' + modal + '.ng.html',
      controller: confirmModalCtrl,
      resolve: {deleteParams: function() {
          return {
            id: $scope.id,
            name: $scope.name
          };
        }}
    });
  };
  $scope.hasPermission = function(permission) {
    if (typeof $scope.permissions == 'undefined' || $scope.permissions == null) {
      return false;
    }
    var index = $scope.permissions.indexOf(permission);
    if (index > -1) {
      return true;
    }
    return false;
  };
  $scope.update = function(id) {
    var fields = transform.toSchema($scope.fields);
    var values = {
      'values': fields.values,
      'id': $scope.id,
      'shortName': $scope.shortName,
      'longName': $scope.longName,
      'lod_data': $scope.lodEntries,
      'description': $scope.description,
      'synonyms': getIds($scope.synonyms),
      'broaderTerms': getIds($scope.broaderTerms),
      'subTerms': getIds($scope.subTerms),
      'preliminary': $scope.preliminary
    };
    $http.post('/api/thesaurus/' + encodeURIComponent(id + '.json'), angular.toJson(values)).then(function(response) {
      window.location = '/thesaurus/' + $scope.name;
    }, function(response) {
      alert("Error saving!");
    });
  };
  $scope.create = function() {
    var fields = transform.toSchema($scope.fields);
    var values = {
      'values': fields.values,
      'id': $scope.id,
      'shortName': $scope.shortName,
      'longName': $scope.longName,
      'description': $scope.description,
      'lod_data': $scope.lodEntries,
      'synonyms': getIds($scope.synonyms),
      'broaderTerms': getIds($scope.broaderTerms),
      'subTerms': getIds($scope.subTerms),
      'preliminary': $scope.preliminary,
      'isCategory': $scope.isCategory,
      'english': $scope.english
    };
    $http.post('/api/thesaurus/' + $scope.name + '/term.json', angular.toJson(values)).then(function(response) {
      window.location = '/thesaurus/' + $scope.name + "/term/" + encodeURIComponent(response.data.id);
    }, function(response) {
      alert("Error saving!");
    });
  };
  $scope.getThesaurus = function() {
    $scope.loading = true;
    var params = {};
    $http.get('/api/thesaurus/' + $scope.name + '.json', {params: params}).success(function(data, status, headers, config) {
      $scope.thesaurustitle = data.displayName[0];
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
    });
  };
  $scope.initFields = function(name, id) {
    $scope.getSchema(name, id);
  };
  $scope.getSchema = function(name, id) {
    $http.get('/api/thesaurus/' + $scope.name + '/schema.json', {}).success(function(data, status, headers, config) {
      $scope.schema = data.schema;
      $scope.getValues(name, id);
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
    });
  };
  $scope.getTerms = function(name, callback, params) {
    $http.get('/api/thesaurus/' + name + '/term.json', {params: params}).success(function(data, status, headers, config) {
      callback(data.terms);
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
    });
  };
  $scope.refresh = function(callback) {
    var params = {query: $scope.query};
    $scope.getTerms($scope.name, callback, params);
  };
  $scope.getValues = function(name, id) {
    if (id == null) {
      $scope.fields = transform.fromSchema($scope.schema, {});
      $scope.id = "";
      $scope.shortName = "";
      $scope.longName = "";
      $scope.description = "";
      $scope.synonyms = [];
      $scope.broaderTerms = [];
      $scope.subTerms = [];
      $scope.preliminary = false;
      $scope.lodEntries = [];
      $scope.english = "";
      return;
    }
    $http.get('/api/thesaurus/' + name + '/term/' + encodeURIComponent(id) + '.json', {}).success(function(data, status, headers, config) {
      $scope.id = data.term.id;
      $scope.shortName = data.term.shortName;
      $scope.longName = data.term.longName;
      $scope.isCategory = data.term.isCategory;
      $scope.description = data.term.description;
      $scope.synonyms = data.term.synonyms;
      $scope.broaderTerms = data.term.broaderTerms;
      $scope.subTerms = data.term.subTerms;
      $scope.preliminary = data.term.preliminary;
      $scope.lodEntries = data.term.lod_data;
      $scope.defaultName = data.term.defaultName;
      $scope.english = data.term.english;
      if (typeof data.term.values != 'undefined') {
        $scope.values = data.term.values;
      } else {
        $scope.values = {};
      }
      $scope.fields = transform.fromSchema($scope.schema, $scope.values);
      console.log($scope.fields);
      $scope.title = $scope.shortName;
      $scope.termPaths = data.term_paths;
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
    });
  };
  $scope.toggleSynonyme = function(value) {
    if (value == true) {
      $scope.query = "";
      $scope.getTerms($scope.name, $scope.setAvailableSynonyms);
    }
    $scope.showSynonyme = value;
  };
  $scope.toggleBroaderTerms = function(value) {
    if (value == true) {
      $scope.query = "";
      $scope.getTerms($scope.name, $scope.setAvailableBroaderTerms);
    }
    $scope.showBroaderTerms = value;
  };
  $scope.toggleSubTerms = function(value) {
    if (value == true) {
      $scope.query = "";
      $scope.getTerms($scope.name, $scope.setAvailableSubTerms);
    }
    $scope.showSubTerms = value;
  };
  $scope.setAvailableSynonyms = function(list) {
    $scope.availableSynonyms = list;
  };
  $scope.setAvailableSubTerms = function(list) {
    $scope.availableSubTerms = list;
  };
  $scope.setAvailableBroaderTerms = function(list) {
    $scope.availableBroaderTerms = list;
  };
  $scope.addTerm = function(list, term) {
    if (_.some(list, function(t) {
      return t.id === term.id;
    }))
      return;
    list.push({
      id: term.id,
      isNew: true,
      shortName: term.shortName,
      longName: term.longName
    });
  };
  $scope.removeTerm = function(list, term) {
    var index = -1;
    for (var i = 0; i < list.length; ++i) {
      if (list[i].id == term.id) {
        index = i;
        break;
      }
    }
    if (index != -1)
      list.splice(index, 1);
  };
  $scope.addLodEntry = function() {
    $scope.lodEntries.push({
      source: $scope.newLodSource,
      id: $scope.newLodId
    });
    $scope.newLodSource = null;
    $scope.newLodId = null;
  };
  $scope.deleteLodEntry = function(index) {
    $scope.lodEntries.splice(index, 1);
  };
  $scope.$watch('[title, thesaurustitle]', function() {
    if (hlp.isSet($scope.id) && hlp.isSet($scope.title)) {
      window.document.title = $scope.title + " - " + $scope.thesaurustitle + " - Thesaurus";
    } else if (hlp.isSet($scope.thesaurustitle)) {
      window.document.title = "Neuer Term - " + $scope.thesaurustitle + " - Thesaurus";
    }
  }, true);
  var getIds = function(list) {
    var result = [];
    list = list || [];
    for (var i = 0; i < list.length; i++) {
      result.push(list[i].id);
    }
    return result;
  };
  init();
};
module.exports = controller;
